import { PMRequirement } from '../types/pm';
import { createProjectItemStore } from './createProjectItemStore';

export const useRequirementStore = createProjectItemStore<PMRequirement>('requirements');
